import {
  ButtonHTMLAttributes,
  ComponentType,
  ReactNode,
  forwardRef,
} from "react";

import { Icon } from "@shared/ui";

type ButtonSecondaryProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text: ReactNode;
  icon?: ComponentType<any>;
  className?: string;
};

const ButtonSecondary = forwardRef<HTMLButtonElement, ButtonSecondaryProps>(
  ({ text, icon, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`flex items-center gap-x-2 px-3 py-2 border border-black bg-white rounded text-sm hover:drop-shadow-md ${className}`}
        {...props}
      >
        {icon ? <Icon icon={icon} /> : null}
        {text}
      </button>
    );
  }
);

ButtonSecondary.displayName = "ButtonSecondary";

export default ButtonSecondary;
